<!-- <simple-notifications [options]="options"></simple-notifications> -->

<div *ngIf="product !== undefined" class=""
     >
  <div
        *ngIf="closeModal"
        style="height: 680px;"
        usbLoadingSplash
        [appLoading]="appLoading"
        [fullscreen]="false"
    ></div>

<ng-container *ngIf="!closeModal">
  <usb-modal-hotel  *ngIf="origin==='HOTELS'" [currencyAgency]="currencyAgency" [currencies]="currencies" [payload]="payload" [clientSetting]="clientSetting" [arrivalDate]="arrivalDate" [departureDate]="departureDate" [hotel]="product" [productQty]="productQty" [form]="form" [view_info]="view_info"
    [payloadUpdate]="payloadUpdate" [paymentAgencyActive]="paymentAgencyActive" [itineraryItem]="itineraryItem" [origin]="origin" [arrayResults]="arrayResults"  [tabActive]="tabActive"  (refModal)="hideModal($event)" [quote]="quote" [action]="action">
  </usb-modal-hotel>

  <usb-modal-pthemes *ngIf="origin==='PTHEMES'" [ptheme]="product" [origin]="origin" [form]="form" [payloadUpdate]="payloadUpdate"
    [itineraryItem]="itineraryItem" [arrayResults]="arrayResults" (refModal)="hideModal($event)"></usb-modal-pthemes>

  <usb-modal-disney *ngIf="origin==='DISNEY'" [hotel]="product" [origin]="origin" [productQty]="productQty" [form]="form" [payloadUpdate]="payloadUpdate"
    [arrayResults]="arrayResults" [_item]="_item"  (refModal)="hideModal($event)">
  </usb-modal-disney>

  <usb-modal-transports *ngIf="origin==='TRANSPORTS'" [tabActive]="tabActive" [service]="product" [currencyAgency]="currencyAgency" [currencies]="currencies" [clientSetting]="clientSetting" [origin]="origin" [productQty]="productQty" [form]="form" [view_info]="view_info"
   [payloadUpdate]="payloadUpdate" [vehicles]="vehicles" [payload]="payload" [paymentAgencyActive]="paymentAgencyActive" [formTransport]="formTransport" [fliyingInfo]="fliyingInfo"  [arrayResults]="arrayResults" [_item]="_item" (refModal)="hideModal($event)" [quote]="quote" [action]="action" [from]="_from">
  </usb-modal-transports>

  <usb-modal-rentacar *ngIf="origin==='RENT-A-CAR'" [rentaCar]="product" [currencyAgency]="currencyAgency" [currencies]="currencies" [origin]="origin"  [productQty]="productQty" [form]="form" [payloadUpdate]="payloadUpdate"
    [itineraryItem]="itineraryItem" [arrayResults]="arrayResults" (refModal)="hideModal($event)" [tabActive]="tabActive" [clientSetting]="clientSetting" [quote]="quote" [action]="action"></usb-modal-rentacar>

  <usb-modal-insurance *ngIf="origin==='INSURANCE'" [insurance]="product" [origin]="origin" [form]="form" [payloadUpdate]="payloadUpdate" [payload]="payload" [clientSetting]="clientSetting"
    [itineraryItem]="itineraryItem" [arrayResults]="arrayResults"  (refModal)="hideModal($event)"></usb-modal-insurance>

  <usb-modal-tours *ngIf="origin==='TOURS'" [tour]="product" [currencyAgency]="currencyAgency" [currencies]="currencies" [origin]="origin" [payloadUpdate]="payloadUpdate" [itineraryItem]="itineraryItem"
    [arrayResults]="arrayResults" [form]="form" (refModal)="hideModal($event)" [paymentAgencyActive]="paymentAgencyActive" [tabActive]="tabActive" [clientSetting]="clientSetting" [quote]="quote" [action]="action" [openInfoDescription]="openInfoDescription" [from]="_from"></usb-modal-tours>

  <usb-modal-packages *ngIf="origin==='PACKAGES'" [packages]="product" [productQty]="productQty" [form]="form" [payloadUpdate]="payloadUpdate"
    [itineraryItem]="itineraryItem" [origin]="origin" [arrayResults]="arrayResults" (refModal)="hideModal($event)">
  </usb-modal-packages>
</ng-container>

</div>
